import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { FxTranslate } from '../../core/translate';
import styles from './card-menu.module.scss';
import { ICardSeccion } from './index.service';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  modo: 'hidden' | 'collapsed' | 'normal';
  width: number;
  onChangeModo: (modo: 'hidden' | 'collapsed' | 'normal') => void;

  secciones?: ICardSeccion[];
  selected?: ICardSeccion;
  onSelectMenu: (seccion: ICardSeccion | undefined) => void;
}

function BoardCardFormMenu({ storage, t,
  modo, width, onChangeModo,
  secciones, selected, onSelectMenu,
} : IProps) {

  if (modo === 'hidden') return <></>;

  return <div className={styles["card-menu-container"]}>
    <i 
      className={`${styles[`collapsed-button`]} pi ${modo !== 'collapsed' ? 'pi-chevron-left' : 'pi-chevron-right'}`} 
      style={{ left: width - 14 }}
      onClick={() => onChangeModo(modo === 'collapsed' ? 'normal' : 'collapsed')}
    ></i>
  
    <div className={styles["card-menu-content"]}>
      {modo === 'normal' && <>
        <div className={styles[`card-menu-menu${!selected ? '-selected' : ''}`]} onClick={() => onSelectMenu(undefined)}>{t(`Menu.undefined`)}</div>
        {secciones?.map(p => 
          <div className={styles[`card-menu-menu${selected?.id === p.id ? '-selected' : ''}`]} onClick={() => onSelectMenu(p)}>{t(`Menu.${p.id}`)}</div>
        )}
      </>}
    </div>
  </div>
  ;
}
export default connect((s:any) => ({ storage:s.main }))(BoardCardFormMenu);
